import { render, staticRenderFns } from "./UserDetailsAnchors.vue?vue&type=template&id=1f644b65&"
import script from "./UserDetailsAnchors.vue?vue&type=script&lang=js&"
export * from "./UserDetailsAnchors.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsAnchors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports